import React, { useEffect, useState } from "react";

const BE = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}`;
const AUTH_BASE = `https://auth2.${BE}`;

export const ReviewQueue = () => {
  const [items, setItems]     = useState([]);
  const [status, setStatus]   = useState("pending");
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  const token = localStorage.getItem("token");

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${AUTH_BASE}/${process.env.REACT_APP_STAGE_ENV}/interest_queue?status=${status}`,
        { headers: { Authorization: token } }
      );
      if (res.status === 403) {
        setError("You do not have permission to view this page.");
        setItems([]);
        return;
      }
      const data = await res.json();
      setItems(data.items || []);
    } catch (e) {
      setError("Failed to load queue");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const act = async (id, action) => {
    await fetch(`${AUTH_BASE}/${process.env.REACT_APP_STAGE_ENV}/interest_action`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ id, action }),
    });
    load();
  };

  return (
    <div style={{ padding: 32, fontFamily: "system-ui, sans-serif" }}>
      <h1 style={{ marginTop: 0 }}>Review Queue</h1>

      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {["pending", "hold", "approved", "rejected", "onboarded"].map(s => (
          <button
            key={s}
            onClick={() => setStatus(s)}
            style={{
              padding: "8px 16px",
              border: "1px solid #ddd",
              borderRadius: 8,
              background: status === s ? "#1a1a1a" : "#fff",
              color: status === s ? "#fff" : "#1a1a1a",
              cursor: "pointer",
            }}
          >
            {s}
          </button>
        ))}
      </div>

      {error && <p style={{ color: "#b00" }}>{error}</p>}
      {loading ? <p>Loading…</p> : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
          <thead>
            <tr style={{ textAlign: "left", borderBottom: "1px solid #ddd" }}>
              <th style={{ padding: 12 }}>Company</th>
              <th style={{ padding: 12 }}>Contact</th>
              <th style={{ padding: 12 }}>CRM</th>
              <th style={{ padding: 12 }}>Restaurants</th>
              <th style={{ padding: 12 }}>APIs</th>
              <th style={{ padding: 12 }}>Created</th>
              <th style={{ padding: 12 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map(it => (
              <tr key={it.id} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: 12 }}>{it.company}</td>
                <td style={{ padding: 12 }}>
                  {it.full_name}<br/>
                  <small style={{ color: "#777" }}>{it.email}</small>
                </td>
                <td style={{ padding: 12 }}>{it.crm}</td>
                <td style={{ padding: 12 }}>{it.restaurant_count}</td>
                <td style={{ padding: 12 }}>{it.api_state}</td>
                <td style={{ padding: 12 }}>{new Date(it.created_at).toLocaleString()}</td>
                <td style={{ padding: 12, display: "flex", gap: 8 }}>
                  <button onClick={() => act(it.id, "approve")}>Approve</button>
                  <button onClick={() => act(it.id, "hold")}>Hold</button>
                  <button onClick={() => act(it.id, "reject")}>Reject</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 24, textAlign: "center", color: "#777" }}>No items</td></tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};